"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CenterV = exports.CenterH = exports.Center = exports.FixedHeight = exports.Overline = exports.H5 = exports.H4 = exports.H3 = exports.H2 = exports.H1 = exports.Caption3 = exports.Caption2 = exports.Caption1 = exports.Body4 = exports.Body3 = exports.Body2 = exports.Body1 = exports.fontWeight = exports.font = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var globals = _interopRequireWildcard(require("@algo/algo-styles/AlgoStyles"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _templateObject19() {
  var data = _taggedTemplateLiteral(["\n    height: 100%;\n    display: flex;\n    align-items: center;\n"]);

  _templateObject19 = function _templateObject19() {
    return data;
  };

  return data;
}

function _templateObject18() {
  var data = _taggedTemplateLiteral(["\n    height: 100%;\n    display: flex;\n    justify-content: center;\n"]);

  _templateObject18 = function _templateObject18() {
    return data;
  };

  return data;
}

function _templateObject17() {
  var data = _taggedTemplateLiteral(["\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n"]);

  _templateObject17 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16() {
  var data = _taggedTemplateLiteral(["\n    height: ", "px;\n    min-height: ", ";\n    max-height: ", ";\n"]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = _taggedTemplateLiteral(["\n    ", ";\n    ", ";\n    font-size: 13px;\n    letter-spacing: 0.077em;\n    line-height: 1.6;\n"]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n    ", ";\n    ", ";\n    font-size: 19px;\n    letter-spacing: 0.012em;\n    line-height: 1.19048;\n"]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n    ", ";\n    ", ";\n    font-size: 24px;\n    letter-spacing: 0.009em;\n    line-height: 1.16667;\n\n    @media only screen and (max-width: ", "){\n        font-size: 28px;\n        letter-spacing: 0.011em;\n        line-height: 1.19048;\n    }\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n    ", ";\n    ", ";\n    font-size: 32px;\n    letter-spacing: 0.004em;\n    line-height: 1.125;\n\n    @media only screen and (max-width: ", "){\n        font-size: 28px;\n        letter-spacing: 0.007em;\n        line-height: 1.14286;\n    }\n\n    @media only screen and (max-width: ", "){\n        font-size: 24px;\n        letter-spacing: 0.009em;\n        line-height: 1.16667;\n    }\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n    ", ";\n    ", ";\n    font-size: 40px;\n    letter-spacing: 0em;\n    line-height: 1.1;\n\n    @media only screen and (max-width: ", "){\n        font-size: 32px;\n        letter-spacing: 0.004em;\n        line-height: 1.125;\n    }\n\n    @media only screen and (max-width: ", "){\n        font-size: 28px;\n        letter-spacing: 0.007em;\n        line-height: 1.14286;\n    }\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n    ", ";\n    ", ";\n    font-size: 48px;\n    letter-spacing: -0.003em;\n    line-height: 1.08365;\n\n    @media only screen and (max-width: ", "){\n        font-size: 40px;\n        letter-spacing: 0em;\n        line-height: 1.1;\n    }\n\n    @media only screen and (max-width: ", "){\n        font-size: 32px;\n        letter-spacing: 0.004em;\n        line-height: 1.125;\n    }\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n    font-size: 11px;\n    letter-spacing: 0.015em;\n    line-height: 1.4545;\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n    ", ";\n    font-size: 12px;\n    letter-spacing: -0.01em;\n    line-height: 1.33341;\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n    ", ";\n    ", ";\n    font-size: 12px;\n    letter-spacing: -0.01em;\n    line-height: 1.33341;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n    ", ";\n    ", ";\n    font-size: 14px;\n    line-spacing: -0.022em;\n    line-height: 1.4;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    ", ";\n    ", ";\n    font-size: 14px;\n    line-spacing: -0.022em;\n    line-height: 1.4;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    ", ";\n    ", ";\n    font-size: 17px;\n    letter-spacing: -0.022em;\n    line-height: 1.47059;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    ", ";\n    ", ";\n    font-size: 17px;\n    letter-spacing: -0.022em;\n    line-height: 1.47059;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["font-weight: 600;"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Nota Sans\", sans-serif"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var font = (0, _styledComponents.css)(_templateObject());
exports.font = font;
var fontWeight = (0, _styledComponents.css)(_templateObject2());
exports.fontWeight = fontWeight;

var Body1 = _styledComponents.default.div(_templateObject3(), function (props) {
  return props.font ? "font-family: ".concat(props.font) : font;
}, function (props) {
  return props.weight ? "font-weight: ".concat(props.weight) : 600;
});

exports.Body1 = Body1;

var Body2 = _styledComponents.default.div(_templateObject4(), function (props) {
  return props.font ? "font-family: ".concat(props.font) : font;
}, function (props) {
  return props.weight ? "font-weight: ".concat(props.weight) : 400;
});

exports.Body2 = Body2;

var Body3 = _styledComponents.default.div(_templateObject5(), function (props) {
  return props.font ? "font-family: ".concat(props.font) : font;
}, function (props) {
  return props.weight ? "font-weight: ".concat(props.weight) : 600;
});

exports.Body3 = Body3;

var Body4 = _styledComponents.default.div(_templateObject6(), function (props) {
  return props.font ? "font-family: ".concat(props.font) : font;
}, function (props) {
  return props.weight ? "font-weight: ".concat(props.weight) : 400;
});

exports.Body4 = Body4;

var Caption1 = _styledComponents.default.div(_templateObject7(), function (props) {
  return props.font ? "font-family: ".concat(props.font) : font;
}, function (props) {
  return props.weight ? "font-weight: ".concat(props.weight) : 600;
});

exports.Caption1 = Caption1;
var Caption2 = (0, _styledComponents.default)(Caption1)(_templateObject8(), function (props) {
  return props.weight ? "font-weight: ".concat(props.weight) : 400;
});
exports.Caption2 = Caption2;
var Caption3 = (0, _styledComponents.default)(Caption2)(_templateObject9());
exports.Caption3 = Caption3;

var H1 = _styledComponents.default.h1(_templateObject10(), function (props) {
  return props.font ? "font-family: ".concat(props.font) : font;
}, function (props) {
  return props.weight ? "font-weight: ".concat(props.weight) : fontWeight;
}, globals.breakpoints.lg, globals.breakpoints.md);

exports.H1 = H1;

var H2 = _styledComponents.default.h2(_templateObject11(), function (props) {
  return props.font ? "font-family: ".concat(props.font) : font;
}, function (props) {
  return props.weight ? "font-weight: ".concat(props.weight) : fontWeight;
}, globals.breakpoints.lg, globals.breakpoints.md);

exports.H2 = H2;

var H3 = _styledComponents.default.h3(_templateObject12(), function (props) {
  return props.font ? "font-family: ".concat(props.font) : font;
}, function (props) {
  return props.weight ? "font-weight: ".concat(props.weight) : font;
}, globals.breakpoints.lg, globals.breakpoints.md);

exports.H3 = H3;

var H4 = _styledComponents.default.h4(_templateObject13(), function (props) {
  return props.font ? "font-family: ".concat(props.font) : font;
}, function (props) {
  return props.weight ? "font-weight: ".concat(props.weight) : fontWeight;
}, globals.breakpoints.lg);

exports.H4 = H4;

var H5 = _styledComponents.default.h5(_templateObject14(), function (props) {
  return props.font ? "font-family: ".concat(props.font) : font;
}, function (props) {
  return props.weight ? "font-weight: ".concat(props.weight) : fontWeight;
});

exports.H5 = H5;

var Overline = _styledComponents.default.div(_templateObject15(), function (props) {
  return props.font ? "font-family: ".concat(props.font) : font;
}, function (props) {
  return props.weight ? "font-weight: ".concat(props.weight) : fontWeight;
});

exports.Overline = Overline;

var FixedHeight = _styledComponents.default.div(_templateObject16(), function (props) {
  return props.height;
}, function (props) {
  return props.minHeight ? "".concat(props.minHeight, "px") : 0;
}, function (props) {
  return props.maxHeight ? "".concat(props.maxHeight, "px") : "none";
});

exports.FixedHeight = FixedHeight;

var Center = _styledComponents.default.div(_templateObject17());

exports.Center = Center;

var CenterH = _styledComponents.default.div(_templateObject18());

exports.CenterH = CenterH;

var CenterV = _styledComponents.default.div(_templateObject19());

exports.CenterV = CenterV;